<template>
  <v-container fluid class="bi-parameter-rule-form-page bi-compact-fields">
    <div class="d-flex align-center mb-3">
      <span class="font-weight-bold foreground--text ui-text-lg">
        {{ form.mode === 'create'
          ? $t('biControlPanel.parameterRules.wizard.createTitle')
          : $t('biControlPanel.parameterRules.wizard.editTitle') }}
      </span>
      <v-spacer />
      <div style="max-width: 500px; width: 100%;">
        <BIParameterRuleStepper />
      </div>
    </div>

    <v-progress-linear v-if="form.loading" indeterminate color="primary" class="mb-3" />

    <v-card v-else class="bi-parameter-rule-step-card pa-3 mb-3" outlined>
      <v-form ref="LevelSelectionStep">
        <LevelSelectionStep @advance="advance" @cancel="cancel" />
      </v-form>
    </v-card>

    <v-scroll-x-transition>
      <div v-if="form.step === 2 && !form.loading">
        <v-form ref="ParameterDetailStep">
          <ParameterDetailStep class="mb-3" />
        </v-form>

        <div class="d-flex flex-row align-center">
          <!-- Na edição o passo 1 é só leitura: o BE não tem endpoint para alterar nível, escopo ou modelo -->
          <div
            v-if="form.mode === 'create'"
            class="primary--text d-flex flex-row align-center"
            style="cursor: pointer;"
            @click="backToStep1"
          >
            <v-icon color="primary" class="mr-2">mdi-arrow-left-circle</v-icon>
            {{ $t('biControlPanel.parameterRules.wizard.back') }}
          </div>
          <v-spacer />
          <v-btn outlined color="primary" class="mr-3" height="42" @click="cancel">
            {{ $t('biControlPanel.parameterRules.wizard.cancel') }}
          </v-btn>
          <v-btn color="primary" elevation="0" height="42" :loading="form.submitting" @click="save">
            {{ $t('biControlPanel.parameterRules.wizard.save') }}
          </v-btn>
        </div>
      </div>
    </v-scroll-x-transition>

    <v-footer class="bi-parameter-rule-form-footer transparent pa-0">
      <v-row class="d-flex justify-end ma-0">
        <v-btn
          outlined
          color="primary"
          width="180px"
          height="36"
          @click="leave"
        >
          {{ $t('common.back') }}
        </v-btn>
      </v-row>
    </v-footer>

    <SnackbarCustomize ref="SnackbarCustomize" />
  </v-container>
</template>

<script>
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import BiPanelRuleModule from '@/store/modules/bi-panel-rule/bi-panel-rule-module';
import BIParameterRuleStepper from './BIParameterRuleStepper.vue';
import LevelSelectionStep from './LevelSelectionStep.vue';
import ParameterDetailStep from './ParameterDetailStep.vue';

export default {
  name: 'BIParameterRuleForm',
  components: {
    BIParameterRuleStepper,
    LevelSelectionStep,
    ParameterDetailStep,
    SnackbarCustomize,
  },
  computed: {
    form() {
      return BiPanelRuleModule.form;
    },
  },
  methods: {
    advance() {
      if (!this.$refs.LevelSelectionStep.validate()) return;

      BiPanelRuleModule.goToFormStep(2);
    },
    backToStep1() {
      BiPanelRuleModule.goToFormStep(1);
    },
    cancel() {
      this.leave();
    },
    leave() {
      BiPanelRuleModule.closeForm();
      this.$router.push({ name: 'BIControlPanel', query: { tab: 'BIParameterRules' } });
    },
    saveErrorMessage(result) {
      if (result.errorCode === 'bi_panel_parameter.duplicate') {
        return this.$t('biControlPanel.parameterRules.messages.duplicateParameterType').toString();
      }

      if (result.errorStatus === 409) {
        return this.$t('biControlPanel.parameterRules.messages.duplicateRule').toString();
      }

      return result.errorMessage || this.$t('biControlPanel.parameterRules.messages.saveError').toString();
    },
    async save() {
      if (!this.form.parameters.length) {
        this.$refs.SnackbarCustomize.open('error', this.$t('biControlPanel.parameterRules.messages.parameterRequired').toString());
        return;
      }

      if (this.$refs.ParameterDetailStep && !this.$refs.ParameterDetailStep.validate()) return;

      const result = await BiPanelRuleModule.submitForm();

      if (!result.success) {
        this.$refs.SnackbarCustomize.open('error', this.saveErrorMessage(result));
        return;
      }

      this.$router.push({ name: 'BIControlPanel', query: { tab: 'BIParameterRules' } });
    },
  },
};
</script>

<style lang="scss">
@import "@/shared/styles/biControlPanel/compactFields.scss";

.bi-parameter-rule-form-page {
  padding: 16px 20px;

  .bi-parameter-rule-step-card {
    border-radius: 8px;
  }

  .bi-parameter-rule-form-footer {
    padding-top: 16px !important;
  }
}
</style>
